export default __webpack_public_path__ + "static/media/errorFilledOrange.f18e5872.svg";